import React from 'react';
import Typography from '@material-ui/core/Typography';
import { statsStyles } from './styles';
import { withStyles } from '@material-ui/core/styles';

let Stats = props => {
    const { classes, stats } = props;
    return (
        <div className={classes.root}>
            {stats.map((stat, index) => (
                <Typography key={index} className={classes.stat}>
                    {stat.label}: {stat.value}
                </Typography>
            ))}
        </div>
    );
};

export default Stats = withStyles(statsStyles)(Stats);
